declare global {
    type Nullable<T> = T | null;
    type OptionValue<T> = {
        value: T;
        label: string;
    };
}
export enum ScopeWagmiKeys {
    USE_BALANCE = 'use-balance'
}
export {};
